import React from 'react';
import { BuilderPage } from '../components/builder/BuilderPage';
import { BUILDER_FIGMA_MODEL, BUILDER_INVESTOR_PAGE_URL } from '../config/builder';

const LandingInvestorPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <BuilderPage urlPath={BUILDER_INVESTOR_PAGE_URL} model={BUILDER_FIGMA_MODEL} />
    </div>
  );
};

export default LandingInvestorPage;
